import { CreditCardType } from '@platform-frontend/payment-util';
import { ScaReason } from './sca-reason';

export interface ScaRedirection {
  cardType: CreditCardType;
  redirectId: string;
  reason: ScaReason;
  url: string;
}
